/** Rotas que aceitam filtro multi-produto (vazio = todos). */
export const MULTI_PRODUCT_PATHS = ['/', '/audit-logs', '/financial-flow'];

export const PRODUCT_SCOPED_PATH_PREFIX = '/platform/products';

const PRODUCT_TAB_KEYS = [
  'tenants',
  'pricing',
  'terms',
  'trial',
  'billing',
  'email',
  'systemadmins',
  'videos'
] as const;

export type ProductFilterMode = 'hidden' | 'single-required' | 'single-all' | 'multi-all';

export function isMultiProductPath(pathname: string): boolean {
  if (pathname === '/') return true;
  return MULTI_PRODUCT_PATHS.some(p => p !== '/' && pathname.startsWith(p));
}

export function platformProductsTab(search: string): string {
  const tab = new URLSearchParams(search).get('tab');
  if (!tab || tab === 'mrr') return 'registry';
  return tab;
}

export function isPlatformProductScopedTab(tab: string): boolean {
  return (PRODUCT_TAB_KEYS as readonly string[]).includes(tab);
}

/** Modo do filtro global no topo conforme rota/aba. */
export function getProductFilterMode(pathname: string, search = ''): ProductFilterMode {
  if (pathname.startsWith('/configurations')) return 'hidden';

  if (pathname.startsWith(PRODUCT_SCOPED_PATH_PREFIX)) {
    const tab = platformProductsTab(search);
    if (tab === 'registry') return 'hidden';
    if (isPlatformProductScopedTab(tab)) return 'single-required';
    return 'hidden';
  }

  if (isMultiProductPath(pathname)) return 'multi-all';

  if (
    ['/billing-metrics', '/nfse-observability', '/impersonation'].some(p => pathname.startsWith(p))
  ) {
    return 'single-all';
  }

  return 'hidden';
}

export function shouldShowProductFilter(pathname: string, search = ''): boolean {
  return getProductFilterMode(pathname, search) !== 'hidden';
}
